import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { project1, project2, project3, project4, project5, project6, rightArrow } from '../../../assets/index';
import { useTranslation } from 'react-i18next';

const Offices = () => { 
  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const projects = [
        { id: 1, image: project1, room: 3, field: 90 },
        { id: 2, image: project2, room: 4, field: 130 },
        { id: 3, image: project3, room: 3, field: 100 },
        { id: 4, image: project4, room: 4, field: 100 },
  ];

  return (
    <div className='max-w-containerSm md:max-w-container mx-auto mt-[44px] md:mt-[80px]'>
      <p className='text-[24px] md:text-[40px] font-bold md:font-semibold font-barlow text-center mb-10'>Geniş və Təchiz Olunmuş <span className='font-barlow text-[#E11E26]'>Ofis Sahələri</span></p>
      <div className='grid grid-cols-1 md:grid-cols-4 gap-4'>
        {projects.map((project) => (
          <a key={project.id} href={`/offices/${project.id}`}>
            <div className="relative md:w-[315px] h-[313px] rounded-[20px] border-[2px] border-[#EFEFEF]">
              <img className="rounded-t-[20px] mb-4 w-full h-[248px]" src={project.image} alt={`Project ${project.id}`} />
              <p className='ml-3 text-[20px]'>{project.room} otaqlı <span>{project.field} m2</span></p>
            </div>
          </a>
        ))}
      </div>
      <div className='mt-5 mx-auto flex justify-center'>
        <a href='/offices'>
          <p className='text-[#E11E26] text-base font-normal inline-block border-b border-[#E11E26]'>Hamısını gör</p>
        </a>
      </div>
    </div>
  );
};

export default Offices; 
